// a11y dialog
document.addEventListener("DOMContentLoaded", (event) => {
  initializeDialogs();

});

// reinitialize dialog when facets are updated
document.addEventListener('facetwp-loaded', function() {
  initializeDialogs();
});



function initializeDialogs() {
  // a11y dialog
  const els = document.querySelectorAll('.a11y-dialog');

  // Instantiate a new A11yDialog module for each element
  els.forEach((el) => {
    const dialog = new A11yDialog(el);

    // lock body scroll when dialog open
    dialog
    .on('show', () => {
      document.documentElement.style.overflowY = 'hidden';

      jQuery('.slider__for').slick('unslick');
      jQuery('.slider__nav').slick('unslick');
      initializeSliders();
    })
    .on('hide', () => (document.documentElement.style.overflowY = ''));
  });
}
